import {
  filter,
  find,
  get,
  isArray,
  isEqual,
  isObject,
  map,
  round,
  size,
  transform,
  uniqBy,
} from 'lodash-es'
import styled from 'styled-components'
import React, { Fragment, PureComponent } from 'react'
import ContentFilters from '@futures-platform/content-filters'
import { usePhenomenonTypes } from '@futures-platform/hooks'
import {
  radarLanguagesWithAll,
  requestTranslation,
} from '@futures-platform/i18n'
import {
  CreateButton,
  OptionDropdown,
  PhenomenonType,
  Radiobox,
  Search,
  SearchInput,
} from '@futures-platform/ui'
import { getPhenomenonUrl } from '../../helpers/helpers'
import { votingApi } from '../../helpers/fetcher'
import RadioBoxForFpScenarios from './RadioBox'

export const PUBLIC_GROUP_VALUE = 0
export const ALL_GROUP_VALUE = -1

function difference(object, base) {
  function changes(object, base) {
    return transform(object, function (result, value, key) {
      if (!isEqual(value, base[key])) {
        result[key] =
          isObject(value) && isObject(base[key])
            ? changes(value, base[key])
            : value
      }
    })
  }

  return changes(object, base)
}

const checkedStyle = { backgroundColor: 'rgb(241, 244, 246)' }
const PAGE_SIZE = 25

class PhenomenonRow extends PureComponent {
  handleClick = () => {
    const { phenomenon, onSelect } = this.props
    onSelect(phenomenon)
  }

  render() {
    const { phenomenon, checked, radarId, listView, phenomenaTypesById } =
      this.props
    let {
      content: { title, short_title, type, halo = false, id, time_range },
      crowdSourcedValue,
    } = phenomenon
    if (!time_range) {
      time_range = {}
    }
    const href = getPhenomenonUrl(listView ? false : radarId, phenomenon, true)
    const phenomenonType = phenomenaTypesById[type]
      ? phenomenaTypesById[type].alias || phenomenaTypesById[type]
      : 'undefined'

    const isFpGroup =
      Number(phenomenon?.group) === 0 ||
      (phenomenon?.groups?.length && Number(phenomenon?.groups[0]) === 0)

    return (
      <PhenomenaRow
        className={'public-phenomena-row'}
        style={checked ? checkedStyle : null}>
        <PhenomenaRowContent onClick={this.handleClick}>
          <RadioBoxForFpScenarios
            className={'align-self-center'}
            label={short_title || title}
            value={id}
            checked={checked}
            phenomenaState={{ halo, type: phenomenonType }}
            isFpGroup={isFpGroup}
          />
          <div className="d-flex flex-column ml-auto" style={{ width: '30%' }}>
            <div>
              {time_range?.min}-{time_range?.max}
            </div>
            <div style={{ fontSize: '11px' }}>
              {requestTranslation('crowdSourced')}{' '}
              {crowdSourcedValue ? crowdSourcedValue : '-'}
            </div>
            <div />
          </div>
        </PhenomenaRowContent>
        <PhenomenaRowControls>
          <button
            className={'btn btn-plain ml-auto align-self-center scenario-link right'}
            data-href={`fp-scenario-card/${phenomenon?.group}/${
              phenomenon?.content?.scenarioSetId ?? null
            }/${phenomenon?.id ?? id}`}
            title={requestTranslation('preview')}>
            <ShowPhenomenonIcon className="material-icons">
              remove_red_eye
            </ShowPhenomenonIcon>
          </button>
        </PhenomenaRowControls>
      </PhenomenaRow>
    )
  }
}

class SandboxPhenomenonRow extends PureComponent {
  render() {
    const {
      phenomenon,
      checked,
      radarId,
      listView,
      phenomenaTypesById,
      onAddToRadarClick,
    } = this.props
    let {
      content: { title, short_title, type, halo = false, id, time_range },
      crowdSourcedValue,
    } = phenomenon
    if (!time_range) {
      time_range = {}
    }
    const href = getPhenomenonUrl(listView ? false : radarId, phenomenon, true)
    const phenomenonType = phenomenaTypesById[type]
      ? phenomenaTypesById[type].alias || phenomenaTypesById[type]
      : 'undefined'
    const isFpGroup =
      Number(phenomenon?.group) === 0 ||
      (!!phenomenon &&
        !!phenomenon?.groups?.length &&
        Number(phenomenon?.groups[0]) === 0)

    return (
      <PhenomenaRow className={'public-phenomena-row'}>
        <PhenomenaRowContent
          className="d-flex align-items-center scenario-link right hoverable"
          data-href={`fp-scenario-card/${phenomenon?.group}/${
            phenomenon?.content?.scenarioSetId ?? null
          }/${phenomenon?.id ?? id}`}>
          <PhenomenonType
            halo={halo}
            type={phenomenonType}
            size={16}
            fill={phenomenonType.style ? phenomenonType.style.color : null}
            isFpGroup={isFpGroup}
          />
          <div className="ml-2">{short_title || title}</div>
        </PhenomenaRowContent>
        <PhenomenaRowControls>
          <AddToRadarButton
            className="btn btn-outline-secondary ml-auto d-flex align-items-center justify-content-center p-0 mr-2"
            onClick={() => onAddToRadarClick(phenomenon)}>
            {requestTranslation('add')}
          </AddToRadarButton>
        </PhenomenaRowControls>
      </PhenomenaRow>
    )
  }
}

class PhenomenaSelectorLegacy extends PureComponent {
  state = {
    textSearchValue: '',
    page: 0,
    loading: false,
    phenomenaList: [],
    totalPages: 0,
    previousFilters: {},
    filtersActive: false,
    groupsProp: {},
  }

  handleScroll = (e) => {
    const { page, totalPages, loading } = this.state
    const { filtersShown } = this.props
    const bottom =
      e.target.scrollHeight - e.target.scrollTop - 25 < e.target.clientHeight

    if (bottom && !loading && page + 1 < totalPages && !filtersShown) {
      this.setState({ page: page + 1 })
    }
  }

  handleTextSearchChange = ({ target }) =>
    this.setState({
      textSearchValue: target.value,
      page: 0,
      phenomenaList: [],
      totalPages: 0,
    })

  handleTextSearchClear = () =>
    this.setState({
      textSearchValue: '',
      page: 0,
      phenomenaList: [],
      totalPages: 0,
    })

  createGroups = () => {
    const { group } = this.props

    const groups = [
      { value: -1, label: requestTranslation('all') },
      { value: 0, label: requestTranslation('publicWord') },
    ]

    if (group) {
      groups.push({ value: group.id, label: group.title })
    }

    return groups
  }

  fetchPhenomenaList = async (filters) => {
    const {
      types,
      times,
      tags,
      // language: languageObj,
      group: selectedGroup,
      page,
      search,
      filtersActive,
    } = filters
    const { previousFilters } = this.state
    const { group, filtersShown, gid } = this.props
    const groupId =
      (group && typeof group === 'object' && group.id) ||
      (typeof group === 'string' || group instanceof String ? gid : group) ||
      0

    let groups =
      selectedGroup.value === ALL_GROUP_VALUE ||
      selectedGroup.value === PUBLIC_GROUP_VALUE
        ? [PUBLIC_GROUP_VALUE]
        : []

    if (!!groupId) {
      groups.push(Number(groupId))
    }

    // let language = get(languageObj, 'value', null)

    // if (language === 'all') {
    //   language = null
    // }

    let newState = {}

    const diff = difference(filters, previousFilters)

    if (diff.page && size(diff) === 1) {
      newState = { loading: true, previousFilters: filters, filtersActive }
      if (filtersShown) {
        return
      }
    } else {
      newState = {
        loading: true,
        previousFilters: filters,
        totalPages: 0,
        phenomenaList: [],
        filtersActive,
        page: 0,
      }
    }

    try {
      const res = await votingApi.searchScenarios({
        query: search,
        groups: groups,
        page,
        size: PAGE_SIZE,
        language: this.props.language || 'en',
        // language: null,

        enhanced: true,
      })

      if (!!res?.data?.result?.length) {
        this.setState({
          phenomenaList: [...this.state?.phenomenaList, ...res?.data?.result],
          totalPages: res?.data?.page?.totalPages || 0,
          loading: false,
        })
      } else {
        this.setState({
          loading: false,
          // phenomenaList: [],
          // totalPages: this.state?.totalPages || 0,
        })
      }
    } catch (error) {
      this.setState({ loading: false })
    }
  }

  isChecked({ id }) {
    const { selectedPhenomena } = this.props

    if (!selectedPhenomena) {
      return false
    }

    if (isArray(selectedPhenomena)) {
      return (
        selectedPhenomena.length > 0 &&
        find(selectedPhenomena, (p) => p.id === id)
      )
    }
    return id === selectedPhenomena.id
  }

  renderSearchResults = () => {
    const {
      radarId,
      listView,
      phenomenaTypesById,
      phenomena: excludedPhenomena,
      onAddToRadarClick,
      sandbox,
      group,
    } = this.props
    const { phenomenaList, loading } = this.state
    return (
      <div className="pr-2">
        {!!phenomenaList?.length &&
          phenomenaList?.map((phenomenon, index) => {
            const { id } = phenomenon
            return (
              <PhenomenonRow
                phenomenaTypesById={phenomenaTypesById}
                listView={listView}
                key={id}
                onSelect={this.props.onSelect}
                phenomenon={phenomenon}
                checked={this.isChecked(phenomenon)}
                radarId={radarId}
              />
            )
          })}
        {loading && (
          <div className="py-2 pl-2">{requestTranslation('loading')}</div>
        )}
        {!phenomenaList?.length && !loading && (
          <p className="ml-4 mt-2 description">No Results found</p>
        )}
      </div>
    )
  }

  render() {
    const {
      onCreate,
      filter,
      group,
      sandbox,
      filtersShown,
      handleFilterChange,
      resetFilters,
      bumpResetFilters,
      isRadar,
      groupsProp,
    } = this.props
    const {
      textSearchValue,
      loading,
      page,
      totalPages,
      previousFilters,
      filtersActive,
    } = this.state

    return (
      <div
        className="d-flex w-100 flex-column"
        style={{ overflow: sandbox ? 'visible' : 'auto' }}>
        <div className="d-flex align-items-center w-100 mb-3">
          {sandbox && (
            <FilterButton
              onClick={handleFilterChange}
              className={`btn-round d-flex align-items justify-content-center position-relative mr-3 ${
                filtersActive ? '' : 'inactive'
              }`}>
              {filtersActive && (
                <FiltersActiveTag className="d-flex align-items-center justify-content-center">
                  <i className="material-icons">done</i>
                </FiltersActiveTag>
              )}
              <i
                className="material-icons d-flex align-items-center justify-content-center"
                style={{
                  fontSize: '20px',
                  transform: 'rotate(-90deg)',
                  fontWeight: 'bold',
                }}>
                tune
              </i>
            </FilterButton>
          )}
          {filtersShown ? (
            <button
              className="btn btn-plain btn-sm ml-auto d-flex align-items-center justify-content-center"
              onClick={handleFilterChange}>
              <i className="material-icons" style={{ fontSize: '16px' }}>
                close
              </i>
              {requestTranslation('closeFilters')}
            </button>
          ) : (
            <Search
              className="mt-0 phenomena-list-search mb-0"
              value={textSearchValue}
              onChange={this.handleTextSearchChange}
              onClear={this.handleTextSearchClear}
            />
          )}
        </div>
        {(filtersShown || filtersActive) && (
          <div className="d-flex align-items-center justify-content-between mb-3">
            <div style={{ fontSize: '12px' }}>
              {loading
                ? requestTranslation('loading')
                : `${totalPages} ${requestTranslation('resultsFound')}`}
            </div>
            {!filtersShown && (
              <button
                className="btn btn-plain btn-sm d-flex align-items-center justify-content-center"
                onClick={bumpResetFilters}>
                <i className="material-icons mr-1" style={{ fontSize: '15px' }}>
                  replay
                </i>
                {requestTranslation('resetFilters')}
              </button>
            )}
          </div>
        )}
        <SearchResultsList
          onScroll={this.handleScroll}
          style={{ border: sandbox ? 'none' : '1px solid #E9ECEC' }}>
          <div
            className="h-100 pr-2"
            style={{ display: filtersShown ? 'block' : 'none' }}>
            <ContentFilters
              page={page}
              search={textSearchValue}
              passedGroups={this.createGroups()}
              onFilterChange={this.fetchPhenomenaList}
              countShown={false}
              resetShown={false}
              manualFilterReset={resetFilters}
              isRadar={isRadar}
              group={group}
              langRadar={this.props.radarLanguage}
              groupsProp={groupsProp}
            />
          </div>
          {!filtersShown && this.renderSearchResults()}
        </SearchResultsList>
      </div>
    )
  }
}

const PhenomenaSelector = (props) => {
  const { group } = props
  const { phenomenonTypesById, loading, error } = usePhenomenonTypes(
    isObject(group) ? group?.id : group,
  )

  if (loading) {
    return <div className="pl-2 py-2">{requestTranslation('loading')}</div>
  }

  if (error) {
    return <div className="pl-2 py-2">{error.message}</div>
  }

  return (
    <PhenomenaSelectorLegacy
      {...props}
      phenomenaTypesById={phenomenonTypesById}
    />
  )
}

export default PhenomenaSelector

const FiltersActiveTag = styled.div`
  position: absolute;
  width: 15px;
  height: 15px;
  background-color: white;
  border-radius: 50%;
  top: -3px;
  left: -3px;
  i {
    font-size: 11.5px;
    color: #006998;
    font-weight: bold;
  }
`

const Loading = styled.div`
  width: 100%;
  z-index: 1000;
  background-color: rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 0;
  flex-direction: column;
`

const SearchRow = styled.div`
  display: flex;
  align-items: flex-start;
`

const SubTitle = styled.h5`
  margin: 0 0 10px;
  position: relative;
  text-align: center;
`

const SearchResultsList = styled.div`
  width: 100%;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  margin-top: 0;
  /*background-color: white;*/
  border-right: 0;
  border-radius: 5px;
  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-thumb {
    background: #c8c8c9;
    border-radius: 20px;
  }

  ::-webkit-scrollbar-track {
    background: white;
    border-radius: 20px;
  }
`

const PhenomenaRowContent = styled.div`
  padding: 0 10px;
  height: 100%;
  display: flex;
  flex: 1 1 100%;
  cursor: pointer;
`

const PhenomenaRowControls = styled.div`
  flex: 0;
  display: flex;
  padding: 0 10px;
  @media (max-width: 1100px) {
    padding: 0;
  }
`

const PhenomenaRow = styled.div`
  display: flex;
  width: 100%;
  min-height: 45px;
  padding: 8px 0;
  box-sizing: border-box;
  align-items: center;
  border-bottom: 1px solid #e9ecec;
  background-color: white;
`

const ShowPhenomenonIcon = styled.span`
  font-size: 26px;
  display: inline-block;
  vertical-align: middle;
`

const FilterButton = styled.div`
  width: 38px !important;
  height: 38px !important;
  flex-shrink: 0;

  &.inactive {
    background-color: transparent !important;
    border: 1px solid #006998;

    i {
      color: #006998;
    }
  }
`

const AddToRadarButton = styled.button`
  height: 22px;
  width: 48px;
  font-size: 11px;
`
